import React, { useEffect, useRef } from "react";
import "./ContactUs.css";
import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaUserTie,
  FaWhatsapp
} from "react-icons/fa";
// import { useNavigate } from "react-router-dom";

function Contact() {
  const rootRef = useRef(null);

  useEffect(() => {
    const container = rootRef.current;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) container.classList.add("contact-show");
        else container.classList.remove("contact-show"); // replays animation
      },
      { threshold: 0.25 }
    );

    observer.observe(container);
    return () => observer.disconnect();
  }, []);

  // const navigate = useNavigate();

  return (
    <div className="contact-wrapper" ref={rootRef}>
      
      {/* HERO */}
      <section className="contact-hero reveal_item fade_in delay_1">
        <div className="hero-overlay">
          <h1 className="nv_title">VB SHAH INC</h1>
          <p>Expert support for your engineering spare parts needs, right when you need it.</p>
        </div>
      </section>

      <div className="main-container">

        <div className="contact-grid">

          {/* LEAD CARD */}
          <div className="lead-contact-card reveal_item slide_up delay_2">
            <div className="card-badge"><FaUserTie /> Direct Support</div>

            <div className="people-flex">
              <div className="person">
                <h4>Vishal Shah</h4>
                <a href="tel:+917948449933">+91 93270 07508</a>
              </div>

              <div className="divider"></div>

              <div className="person">
                <h4>Office</h4>
                <a href="tel:+919825019808">7948449933</a>
              </div>
            </div>
          </div>

          {/* DETAILS GRID */}
          <div className="details-grid">
            <div className="detail-card reveal_item scale_fade delay_3">
               <FaMapMarkerAlt className="detail-icon" />
              <h3>Visit Our Office</h3>
              <p>VB SHAH.   E1-3rd Floor NIKUMBH Complex, Opp. Tomato Restaurent , Behind RAINDROPS, Off C G Road, Ahmedabad.  380006</p>
              <button
  className="action-link"
  onClick={() =>
    window.open(
      "https://www.google.com/maps/place/Shreeraj+Corporation,+Nikumbh+Complex,+Ellisbridge,+Ahmedabad",
      "_blank"
    )
  }
>
  Get Directions
</button>
            </div>


           <div className="detail-card reveal_item scale_fade delay_4">
  <FaPhoneAlt className="detail-icon" />
  <h3>Call Us</h3>

  <p>Cell: +91 7948449933</p>
  <p className="sub-text">Mon - Sat: 10:30 AM - 7:30 PM</p>

  <button
    className="action-link"
    onClick={() => (window.location.href = "tel:+919913799333")}
  >
    Call Now
  </button>
</div>


            <div className="detail-card reveal_item scale_fade delay_5">
             <FaEnvelope className="detail-icon" />
              <h3>Email Inquiry</h3>
              <p>sales@vbshah.com</p><br></br>
              <p className="sub-text"></p>
              <button
  className="action-link"
  onClick={() =>
    window.location.href = "mailto:sales@vbshah.com"
  }
>
  Send Email
</button>
            </div>

        <div className="detail-card reveal_item scale_fade delay_5">
             <FaWhatsapp className="detail-icon" />
              <h3>Direct WhatsApp Support</h3>
              {/* <p>Salesvbshah@gmail.com</p> */}
              <p className="sub-text"></p>
              <button
  className="action-link"
  onClick={() =>
    window.open(
      "https://wa.me/919327007508?text=Hi",
      "_blank"
    )
  }
>
  WhatsApp
</button>

            </div>


          </div>

          {/* MAP */}
          {/* <div className="map-section reveal_item slide_up delay_6">
            <iframe
              title="Location Map"
              src="https://www.google.com/maps/embed?pb=!1m19!1m8!1m3!1d58750.55844114682!2d72.5578468!3d23.0270801!3m2!1i1024!2i768!4f13.1!4m8!3e6!4m0!4m5!1s0x395e84777925d7ff%3A0x203104740349b59e!2sShreeraj%20Corporation%2C%20Nikumbh%20Complex%2C%20Ellisbridge%2C%20Ahmedabad%2C%20Gujarat%20380006!3m2!1d23.0270801!2d72.5578468!5e0!3m2!1sen!2sin!4v1770913979699!5m2!1sen!2sin "
              allowFullScreen=""
              loading="lazy"
            ></iframe>
          </div> */}

        </div>
      </div>
    </div>
  );
}

export default Contact;
